import { Pipe, PipeTransform } from '@angular/core';
import { NavLinksWithIcon } from '../navigation';

@Pipe({
  name: 'showNav'
})
export class ShowNavPipe implements PipeTransform {

  transform(navs: NavLinksWithIcon[]): NavLinksWithIcon[] {
    return (navs || []).filter(nav => nav.show);
  }

}
